import { useCallback } from "react";

import type { EventDefinition } from "../../types/index.ts";
import { useTriggerDesigns } from "../TriggerDesignsContext.ts";
import { useNodeTriggerConditionProp } from "./useNodeTriggerConditionProp.ts";

export const useNotifyTriggerCaseAdd = (nodeId: number) => {
  const { getTriggersForEventType } = useTriggerDesigns();
  const nodeTriggerConditionProp = useNodeTriggerConditionProp(nodeId);

  return useCallback(
    (definition: EventDefinition) => {
      const onTriggerCaseAdd = definition.whereConditionBuilder?.onTriggerCaseAdd;
      if (!onTriggerCaseAdd) return;

      const config = definition.whereConditionBuilder?.getInitialConfig?.() ?? {};
      const allTriggersForEventType = getTriggersForEventType(nodeId, definition.type);
      const otherConfigs = allTriggersForEventType.flatMap((t) =>
        t.cases.filter((c) => c.eventType === definition.type).map((c) => c.where?.config ?? {}),
      );
      onTriggerCaseAdd({ config, otherConfigs, node: nodeTriggerConditionProp });
    },
    [getTriggersForEventType, nodeId, nodeTriggerConditionProp],
  );
};
